import { UseQueryResult } from '@tanstack/react-query'
import { useEffect, useMemo } from 'react'

interface ImageData {
    id: number
    blob: Blob
}

type ImageQueryResult = UseQueryResult<ImageData>

export function useBlobUrls(queries: ImageQueryResult[]) {
   const urls = useMemo(() => {
        return queries.map((q) => {
            if (!q?.data?.blob) return undefined
            return URL.createObjectURL(q.data.blob)
        })
    }, [queries])

    useEffect(() => {
        return () => {
            urls.forEach((url) => url && URL.revokeObjectURL(url))
        }
    }, [urls])

    return urls
}
